import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import { ThemeContext } from 'styled-components';
import { IconName, IconSize } from '../../../../../../../components/Atoms/Icon/Icon.enum';
import { TextSizeType } from '../../../../../../../shared/styling/BaseText/BaseText.enum';
import { Icon } from '../../../../iconsHelper';
import { createTestId } from '../../../../utils';
import { Button, Counter, CounterWrapper, IconText, IconWrapper, ItemWithAvatar, StyledLink, Wrapper, } from './AsideMenuItem.styled';
export const AsideMenuItem = ({ slug, url, onClick, onHover, count = 0, icon, name, isVisible, avatar, dropdownComponent: Dropdown, customIcon, isUserLoggedIn, }) => {
    const [isHovered, setIsHovered] = useState(false);
    const theme = useContext(ThemeContext);
    const onClickHandler = (e) => {
        if (onClick) {
            e.preventDefault();
            e.stopPropagation();
            onClick();
        }
    };
    const showPopupOnDesktop = () => {
        if (window.innerWidth >= theme.screenSizes.medium) {
            setIsHovered(true);
            onHover && onHover();
        }
    };
    const hidePopupOnDesktop = () => {
        if (window.innerWidth >= theme.screenSizes.medium) {
            setIsHovered(false);
        }
    };
    const MenuItem = url ? StyledLink : Button;
    const menuItemProps = url ? { href: url } : {};
    const isJoinItem = name === 'Join';
    const shouldDisplayAccount = isJoinItem && isUserLoggedIn;
    return (_jsxs(Wrapper, Object.assign({ "data-testid": "aside-menu-item", isCart: slug === 'cart', isVisible: isVisible, onMouseEnter: showPopupOnDesktop, onMouseLeave: hidePopupOnDesktop }, { children: [_jsx(MenuItem, Object.assign({ "data-testid": createTestId(`aside-menu-item-${slug}`, isHovered) }, menuItemProps, { onClick: onClickHandler }, { children: _jsx(IconWrapper, { children: avatar ? (_jsxs(ItemWithAvatar, { children: [_jsx("img", { alt: "user avatar", height: 38, src: avatar, width: 38 }, void 0), _jsx(Icon, { height: 10, name: IconName.CHEVRON_DOWN }, void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [icon && _jsx(Icon, { height: 22, name: icon, size: IconSize.SIZE24 }, void 0), customIcon !== null && customIcon !== void 0 ? customIcon : null, +count > 0 && (_jsx(CounterWrapper, { children: _jsx(Counter, Object.assign({ "data-testid": createTestId(`counter-${slug}-container`) }, { children: count }), void 0) }, void 0)), _jsx(IconText, Object.assign({ isAccount: shouldDisplayAccount, textSize: TextSizeType.TEXT12 }, { children: shouldDisplayAccount ? 'Account' : name }), void 0)] }, void 0)) }, void 0) }), void 0), isHovered && Dropdown ? _jsx(_Fragment, { children: Dropdown }, void 0) : null] }), void 0));
};
//# sourceMappingURL=AsideMenuItem.js.map